import { render, staticRenderFns } from "./PaySettingsTabs.vue?vue&type=template&id=05c0a494&scoped=true"
import script from "./PaySettingsTabs.vue?vue&type=script&lang=js"
export * from "./PaySettingsTabs.vue?vue&type=script&lang=js"
import style0 from "./PaySettingsTabs.vue?vue&type=style&index=0&id=05c0a494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c0a494",
  null
  
)

export default component.exports